module.exports = __webpack_public_path__ + "static/media/gryff.6322ca57.png";